import * as React from "react";

import { cn } from "@/lib/utils";

interface InputGroupProps
  extends Omit<React.ComponentProps<"input">, "prefix"> {
  suffix?: React.ReactNode;
  startAdornment?: React.ReactNode;
}

function InputGroup({
  className,
  suffix,
  startAdornment,
  type,
  ...props
}: InputGroupProps) {
  return (
    <div className="relative flex items-center">
      {startAdornment && (
        <div className="text-muted-foreground absolute left-3 flex items-center pointer-events-none text-sm">
          {startAdornment}
        </div>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-sm border bg-background-elevated px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          startAdornment && "pl-8",
          suffix && "pr-7",
          className
        )}
        {...props}
      />
      {suffix && (
        <div className="text-muted-foreground absolute right-3 flex items-center pointer-events-none text-sm">
          {suffix}
        </div>
      )}
    </div>
  );
}

export { InputGroup };

